import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
    Card,
    CardBody,
    Col,
    Row,
    Input,
    Table,
    Pagination,
    PaginationItem,
    PaginationLink,
    CardHeader,
    Spinner,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchHistory,
    selectHistory,
    selectHistoryLoading,
    selectHistoryError
} from '../../rtk/slices/historySlice/historySlice';
import { apiKey } from '../../utils/config';
import { format, isWithinInterval, subDays, subMonths, subYears } from 'date-fns';
import { selectFilterType } from '../../rtk/slices/filterSlice/filterSlice';
import FilterDropdown from './FilterDropdown';
import UserCheckModal from './UserCheckModal';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../firebase';



const DesktopHistoryPositions = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    // const historyPositions = useSelector(selectHistory);
    const [historyPositions, setHistoryPositions] = useState([]);
    const loading = useSelector(selectHistoryLoading);
    const error = useSelector(selectHistoryError);
    const filterType = useSelector(selectFilterType);

    const [filteredPositions, setFilteredPositions] = useState([]);

    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');


    const path = location.pathname;
    const currentPath = path === '/history'


// console.log('historyPositions', historyPositions);


    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = currentPath ? 25 : 10;

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const account = user ? user.account : null;

    const tradesRef = collection(db, 'trades_collection')
    const q = query(
      tradesRef,
      where('account', '==', account),
      where('status', '==', 'completed')
    )
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const trades = querySnapshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
      setHistoryPositions(trades);
    });

 return () => unsubscribe();
    // if (account) {
    //   dispatch(fetchHistory({ api_key: apiKey, account }));
    // }
  }, []);

    useEffect(() => {
        const today = new Date();
        let startDate;

        switch (filterType) {
            case 'Today':
                startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                break;
            case 'Last week':
                startDate = subDays(today, 7);
                break;
            case 'Last month':
                startDate = subMonths(today, 1);
                break;
            case 'Last 3 months':
                startDate = subMonths(today, 3);
                break;
            case 'Last 6 months':
                startDate = subMonths(today, 6);
                break;
            case 'Last year':
                startDate = subYears(today, 1);
                break;
            case 'Custom':
                startDate = customStartDate ? new Date(customStartDate) : null;
                break;
            case 'All':
            default:
                startDate = null;
        }

        const newFilteredPositions = historyPositions.filter((position) => {
            const openTime = new Date(position.open_time_formated);
            const isInCustomRange = (customStartDate && customEndDate) ?
                isWithinInterval(openTime, { start: new Date(customStartDate), end: new Date(customEndDate) }) :
                false;

            const excludeBalanceType = (position.type === "DEAL_BALANCE" && position.symbol === "") || position.profit === 0;

            return !excludeBalanceType && (
                filterType === 'All'
                    ? true
                    : (filterType === 'Custom'
                        ? isInCustomRange
                        : (startDate ? isWithinInterval(openTime, { start: startDate, end: today }) : true))
            );
        });

        setFilteredPositions(newFilteredPositions);
        setCurrentPage(1); // Reset to the first page when filter changes
    }, [filterType, historyPositions, customStartDate, customEndDate]);

    // Calculate pagination
    const totalItems = filteredPositions.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredPositions.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };


    // Calculations for summary of filtered positions
    const totalDeposit = historyPositions
        .filter(position => position.type === "DEAL_BALANCE" && position.symbol === "")
        .reduce((sum, position) => sum + position.profit??0, 0);



    const totalProfit = filteredPositions.reduce((sum, position) => sum + position.profit??0, 0);
    const totalSwap = filteredPositions.reduce((sum, position) => sum + position.swap??0, 0);
    const totalCommission = filteredPositions.reduce((sum, position) => sum + position.commssion??0, 0);
    const totalWithdrawal = 0; // Assuming withdrawal is part of summary
    const totalBalance = totalDeposit + totalProfit - totalSwap - totalCommission - totalWithdrawal;

    return (
        <div className={currentPath ? 'page-content py-0 pe-0' : null}>

            {/* {
                currentPath ? <>
                    <UserCheckModal message="To view you orders history, please select your trading account first." />
                </> : <></>
            } */}

            <Card className='mb-0'>
                {
                    currentPath ? <>
                        <CardHeader>
                            <Row className='justify-content-end'>
                                <FilterDropdown />
                            </Row>
                        </CardHeader>
                    </> : <></>
                }
                <CardBody className='p-0'>
                    {filterType === 'Custom' && (
                        <div className="d-flex justify-content-between mb-3">
                            <Input
                                type="date"
                                placeholder="Start Date"
                                value={customStartDate}
                                onChange={(e) => setCustomStartDate(e.target.value)}
                            />
                            <Input
                                type="date"
                                placeholder="End Date"
                                value={customEndDate}
                                onChange={(e) => setCustomEndDate(e.target.value)}
                            />
                        </div>
                    )}

                    <Table className={currentPath ? 'text-center' : 'text-center trading-t-table'} >
                        <thead  className='bg-body'>
                            <tr>
                                <th>#</th>
                                <th>Symbol</th>
                                <th>Type</th>
                                <th>Volume</th>
                                <th>Price</th>
                                <th>Current Price</th>
                                <th>Profit</th>
                                <th>Open Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="11" className="text-center">
                                        <Spinner size="sm" color="primary" /> Loading...
                                    </td>
                                </tr>
                            )
                                :
                                error ? (
                                    // Render error row if there's an error
                                    <tr>
                                        <td colSpan="11" className="text-center" style={{color:"#dc3a48"}}>
                                            {" Page you are looking for doesn't exit or an other error ocurred or temporarily unavailable."}
                                            {" Please try again."}
                                        </td>
                                    </tr>
                                )
                                    : currentItems.length > 0 ? (
                                        currentItems.map((position, index) => {
                                            const orderType = position.type === "DEAL_BUY" ? 'BUY' : position.type === "DEAL_SELL" ? "SELL" : position.type;

                                            return (
                                                <tr className='opd-tr' key={`${position.id}-${index}`}>
                                                    <td>{indexOfFirstItem + index + 1}</td>
                                                    <td>{position.symbol}</td>
                                                    <td>
                                                        <span
                                                            className={`badge cursor-pointer ${orderType === 'SELL' ? 'bg-primary-subtle text-primary' : 'bg-secondary-subtle text-secondary'
                                                                }`}
                                                        >
                                                            {orderType}
                                                        </span>
                                                    </td>
                                                    <td
                                                        className={`${orderType === 'SELL' ? 'text-primary' : 'text-secondary'
                                                            }`}
                                                    >{position.volume}</td>
                                                    <td>{position.price}</td>
                                                    <td>{position.current_price}</td>
                                                    <td style={{ color: position.profit ?? 0 < 0 ? "#DC3A48" : "#3577f1" }}>
                                                        {position.profit?.toFixed(2) ?? 0}
                                                    </td>
                                                   <td>{position.closedAt ? new Date(position.closedAt).toLocaleString() : '—'}</td>

                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">No history available.</td>
                                        </tr>
                                    )}
                        </tbody>
                    </Table>


                    {/* Pagination Controls */}
                    {totalPages > 1 && (


                        <div className='d-flex align-items-center bg-body trading-t-footer px-2 justify-content-between'>
                            {
                                (!error) && (
                                    <p className='mb-0'>
                                        <strong>Total Deposit:</strong>{totalDeposit.toFixed(2)}
                                        &nbsp;&nbsp;&nbsp;

                                        <strong>Total Profit:</strong>{totalProfit.toFixed(2)}
                                        &nbsp;&nbsp;&nbsp;


                                        <strong>Total Swap:</strong> {totalSwap.toFixed(2)}
                                        &nbsp;&nbsp;&nbsp;

                                        <strong>Total Commission:</strong> {totalCommission.toFixed(2)}
                                        &nbsp;&nbsp;&nbsp;


                                        <strong>Total Balance:</strong> <span> {totalBalance.toFixed(2)}</span>
                                    </p>
                                )
                            }
                            <Pagination className="justify-content-center mt-3 history-pagination" >
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink
                                        previous
                                        onClick={() => handlePageChange(currentPage - 1)}
                                    >
                                        Previous
                                    </PaginationLink>
                                </PaginationItem>
                                <PaginationItem>
                                    <span className="pagination-indicator">
                                        {currentPage} / {totalPages}
                                    </span>
                                </PaginationItem>
                                <PaginationItem disabled={currentPage === totalPages}>
                                    <PaginationLink
                                        next
                                        onClick={() => handlePageChange(currentPage + 1)}
                                    >
                                        Next
                                    </PaginationLink>
                                </PaginationItem>
                            </Pagination>

                        </div>
                    )}

                </CardBody>
            </Card>
        </div>
    );
};

export default DesktopHistoryPositions;
